<template>
  <h1 class="text-4xl font-bold">
    <AnexisTitle>
      <slot />
    </AnexisTitle>
  </h1>
</template>

<script setup lang="ts">
import AnexisTitle from "../components/AnexisTitle.vue";
</script>
